<form [formGroup]="additionalInformationForm" class="additional-info-form">
    <div>
        <form-label [label]="subtitle(7162)"></form-label>
        <form-text-input [inputControl]="cityControl"
                         [placeholder]="subtitle(7162)">
        </form-text-input>
        <form-label [label]="subtitle(7161)"></form-label>
        <form-text-input [inputControl]="streetControl"
                         [placeholder]="subtitle(7161)">
        </form-text-input>
        <form-label [label]="subtitle(7163)"></form-label>
        <form-text-input [inputControl]="houseNumberControl"
                         [placeholder]="subtitle(7163)">
        </form-text-input>
        <form-label [label]="subtitle(4697)"></form-label>
        <form-text-input [inputControl]="phoneControl"
                         [telType]="true"
                         [placeholder]="subtitle(4697)">
        </form-text-input>
        <form-label [label]="subtitle(6440)"></form-label>
        <form-text-input [inputControl]="installerInformationControl"
                         [placeholder]="subtitle(6440)">
        </form-text-input>
    </div>
    <form-action-buttons>
        <form-button [subtitle]="subtitle(71)"
                     [btnType]="'cancel'"
                     (click)="closeForm()">
        </form-button>
        <form-button [subtitle]="subtitle(1255)"
                     [btnType]="'confirm'"
                     (click)="sendContactData()">
        </form-button>
    </form-action-buttons>
</form>
